const SET_LIST = (state, obj) => {
  state.list = obj
}

const SET_ERRORS_DOCS = (state, obj) => {
  state.errors.docs = obj
}

const RESET_ERRORS = (state) => {
  state.errors = { ...state.initialErrors }
}

const RESET_ERRORS_DOCS = (state) => {
  state.errors.docs = []
}

export default {
  RESET_ERRORS,
  SET_ERRORS_DOCS,
  RESET_ERRORS_DOCS,
  SET_LIST
}



// WEBPACK FOOTER //
// ./src/features/payer_invoice_upload/store/mutations.js